import React, { useMemo } from 'react';
import AGGridComponent from '../../../../components/AgGrid/AGGridComponent';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { PrivateBankingServiceDefinitionId, ServiceRole } from 'pco-product-service-internal-consumer';
import { ZfTypography } from '@zafire/react';
import { filterVisibleServiceRoles } from '../../../../utils/serviceRoleStatusUtils';
import { getServiceRoleColumns } from './serviceRoleColumns';

export type ServiceRoleUsersBlockProps = {
  serviceRoles?: ServiceRole[];
  serviceDefinitionId?: PrivateBankingServiceDefinitionId;
};

const baseColumns: ColDef<ServiceRole>[] = [
  {
    field: 'fullName',
    headerName: 'Name',
    sortable: true,
    resizable: false,
    filter: true,
    flex: 0,
    width: 130,
    pinned: 'left',
  },
  {
    field: 'partnerNumber',
    headerName: 'ID',
    sortable: false,
    resizable: true,
    filter: true,
    flex: 1,
    minWidth: 110,
    filterParams: {
      valueFormatter: (params: ValueFormatterParams) => params.value,
    },
  },
];

export const ServiceRoleUsersBlock: React.FC<ServiceRoleUsersBlockProps> = ({ serviceRoles, serviceDefinitionId }) => {
  const columnDefs = useMemo<ColDef<ServiceRole>[]>(
    () => [...baseColumns, ...getServiceRoleColumns(serviceDefinitionId)],
    [serviceDefinitionId],
  );
  const visibleServiceRoles = useMemo(() => filterVisibleServiceRoles(serviceRoles), [serviceRoles]);

  if (visibleServiceRoles.length === 0) {
    return (
      <ZfTypography data-testid="e-banking-users-table-empty" variant="body-medium">
        No partners are added as service roles
      </ZfTypography>
    );
  }

  return (
    <AGGridComponent
      id="e-banking-users-table"
      items={visibleServiceRoles as unknown as Record<string, unknown>[]}
      getColumnDefs={columnDefs}
      rowKey="partnerNumber"
      disableSelection={true}
      showPagination={false}
      suppressRowHoverHighlight={true}
      rowHeight={44}
      disableSizeColumnsToFit={true}
    />
  );
};
